import React from 'react';
import './DataBlock.css';

function DataBlock(props) {
  return (
    <div className="data-block">
      <h3 className="block-label">
        {props.label}
      </h3>
      <div className="block-contents">
        {props.children}
      </div>
    </div>
  );
}

export default DataBlock;


/** WEBPACK FOOTER **
 ** ./src/DataBlock/DataBlock.js
 **/